// extracted by mini-css-extract-plugin
export default {"aside":"Dashboard_aside__cV968"};